<template>
  <div>
    <CRow>
      <CCol class="text-center ">
        <label class="h2 text-dark"> Voice </label>
      </CCol>

      <CCol class="text-center ">
        <label class="h2 text-dark"> Voice </label>
      </CCol>
    </CRow>
  </div>
</template>

<script>

import Vue from 'vue'
import {mapGetters} from 'vuex'
export default {
  name: 'ConfigLogin',
  props: {
  },

  data: function () {
    return {

    }
  },

  mounted () {

  },

  created () {
    this.onInit()
  },

  beforeDestroy () {

  },

  methods: {
    onInit(){

    },

  },

  computed:{
    ...mapGetters({

    })
  },

  watch: {

  }

}
</script>
<style>

</style>
